'use es6';

import { omit } from 'underscore';
import Interframe from 'interframe';
import { Events } from 'Backbone';
export default class EventBus {
  constructor() {
    this.parentIsReadyToReceive = false;
    this.queuedMessages = [];
    this.onPostMessage = message => {
      if (message.action === 'reduxAction') {
        const reduxAction = omit(message, 'action');
        this.trigger('reduxAction', reduxAction);
        if (this.store) {
          this.store.dispatch(reduxAction);
        }
      } else {
        this.trigger(`post:${message.action}`, message);
      }
    };
    this.postMessage = (message, type) => {
      if (this.parentIsReadyToReceive) {
        return this.messenger.postMessage(message, type);
      }
      this.queuedMessages.push({
        message,
        type
      });

      // Intentionally assuming that any messages that could be send before the parent is ready
      // (mostly `inpageAppMessagingReady`) do not need a return value

      return undefined;
    };
    this.dispatchAction = action => {
      // Support thunks even when dispatching to the parent
      if (typeof action === 'function') {
        action(this.dispatchAction, this.store.getState);
      } else {
        this.messenger.postMessage(Object.assign({
          action: 'reduxAction',
          source: 'iframe'
        }, action));
      }
    };
    this.dispatchActionToEventBus = (action, messageType) => {
      const reformattedAction = Object.assign({}, action, {
        action: action.type
      });
      delete reformattedAction.type;
      return this.messenger.postMessage(reformattedAction, messageType);
    };
    Object.assign(this, Events);
    this.messenger = new Interframe(window.hsVars.app_hs_base_url, window.parent);
    this.messenger.subscribe(this.onPostMessage);
  }
  setStore(store) {
    this.store = store;
  }
  checkIfParentIsReadyToRecieve() {
    // Skip this.postMessage because we don't want inpageAppMessagingReady to be queued
    this.messenger.postMessage({
      action: 'inpageAppMessagingReady'
    });
  }
  letParentKnowWeGotTheReadyMessage() {
    // Skip this.postMessage because we don't want inpageAppMessagingReady to be queued
    this.messenger.postMessage({
      action: 'inpageAppInitializationStarted'
    });
  }
  parentIsReady() {
    this.parentIsReadyToReceive = true;
    if (this.queuedMessages.length > 0) {
      this.queuedMessages.forEach(({
        message,
        type
      }) => {
        this.postMessage(message, type);
      });
    }
  }

  // NOTE This is only used in tinymce. If you want the parent app to handle actions
  // dispatched from within the inpage app, dispatch them as you would normally
  // and postMessageMiddleware will make sure they get dispatched in the parent.
  // Dispatch an inpage "action" which which is sent to the parent as a regular `post:foobar` messsage
  // In other words, use the same old-school postMessage format, but make things _seem_ more like
  // Redux to the consumer
}